module.exports = __webpack_public_path__ + "static/media/goldmansachs_logo_simple.03b83a43.svg";